import React from 'react';
import { Button, Row, Col, Form, Collapse, Card} from 'react-bootstrap';
import { useEffect } from 'react';
import { useState } from 'react';
import ActionRequestService from '../../services/action-request';
import { FundType } from '../../helpers/Enum/index';
import { parseDateBR } from 'helpers/date.js';
import EditIcon from '@material-ui/icons/Edit';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Can from 'components/Can';
import Loading from 'components/Loading';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import { DebounceInput } from 'react-debounce-input';
import { faTimesCircle, faFilter } from '@fortawesome/free-solid-svg-icons';
import styles from './style.module.scss';
import DatePicker from "react-datepicker";

const ListActions = ({ flowSelected, currentCompany, fiscalYear }) => {
  const defaultFilters = {
    __search: '',
    __date1: '',
    __fiscal_year_id: fiscalYear || 13,
    per_page: 10,
    page: 1,
    sort_by: 'id'
  }

  const [filters, setFilters] = useState(defaultFilters);
  const [actions, setActions] = useState([]);
  const [pagination, setPagination] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [token_cancel_request, set_token_cancel_request] = useState(null);

  useEffect(() => {
    function conectar() {
      getActions();
    }
    conectar();
  }, [flowSelected, filters, fiscalYear])

  const getActions = () => {
    setIsLoading(true);
    if (token_cancel_request)
      token_cancel_request.cancel('Não é mais de meu interesse enviar esta requisição.');

    let aux_token_cancel_request = Axios.CancelToken.source();
    set_token_cancel_request(aux_token_cancel_request);
    let filters_aux = {
      ...filters,
      embed: 'funds,action_status,company.commercialDirectors',
      fiscal_year_id: fiscalYear,
      action_status_id: flowSelected,
      __type_id: FundType().ScanSourceSelect
    };
    if (currentCompany)
      filters_aux["company_id"] = currentCompany.id;

    let request = ActionRequestService.getByArea(1, { params: { ...filters_aux }, cancelToken: aux_token_cancel_request.token });
    request.then(data => {
      let actions = data.data.data;
      actions = actions.filter(action => {
        return action.funds[0];
      });
      setActions(actions);
      setPagination(data.data.pagination);
      setIsLoading(false);
    }).catch(() => setIsLoading(true));
  }

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const handlePageChange = page => handleFilterChange({ page });

  const [open, setOpen] = useState(false);

  const minWidth = 370;
  const isMobile = window.innerWidth < minWidth;

  const getTamanho = (tamanho) => {
    return window.innerWidth <= tamanho;
  }

  return (
    <div>
      <Collapse in={open}>
        <Row id="example-collapse-text">
          <Col xs={12} md={3}>
            <Form.Group>
              <Form.Label className="text-left">Pesquisar:</Form.Label>
              <DebounceInput
                element={Form.Control}
                debounceTimeout={500}
                value={filters.__search}
                onChange={({ target }) => {
                  handleFilterChange({ __search: target.value, page: 1 })
                }}
              />
              <FontAwesomeIcon icon={faTimesCircle} className={styles.searchclear}
                onClick={()=>handleFilterChange({ __search: '', page: 1 })}/>
            </Form.Group>
          </Col>
          {/* <Col xs={12} md={2}>
            <Form.Group>
              <Form.Label className="text-left">Ano Fiscal:</Form.Label>
              <Form.Control
                as="select"
                value={filters.__fiscal_year_id}
                onChange={e => {}}
              >
                <option value="0">Todos</option>
                <option value="3">ScanCash</option>
                <option value="2">Resgate</option>
              </Form.Control>
            </Form.Group>
          </Col> */}
          <Col xs={12} md={2}>
            <Form.Group>
              <Form.Label>Data:</Form.Label>
              <DatePicker
                selected={filters.__date1}
                onChange={e=>handleFilterChange({ __date1: e, page: 1 })}
                onChangeRaw={e=>{e.preventDefault();}}
                className='form-control'
              />
              <FontAwesomeIcon icon={faTimesCircle} className={styles.searchclear}
              onClick={()=>handleFilterChange({ __date1: '', page: 1 })}/>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group>
              <Form.Label>Tipo:</Form.Label>
              <Form.Control
                as="select"
                value={filters.__type}
                onChange={e =>{
                  handleFilterChange({ __type: e.target.value, page: 1 })
                }}
              >
                <option value="0">Todos</option>
                <option value="6">Abatimento no Pedido</option>
                <option value="2">Reembolso</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
      </Collapse>
      <Row className="justify-content-between">
        <Col xs='auto' md={3} className="p-1">
          <Form.Group>
            <Form.Label className="text-left">Registros por página:</Form.Label>
            <Form.Control
              as="select"
              value={filters.per_page}
              onChange={e =>
                handleFilterChange({ per_page: e.target.value, page: 1 })
              }
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col xs={'auto'} className="d-flex align-items-center p-1">
          <Button
          className=""
          onClick={() => {
            if(open)
              handleFilterChange({ __date1: '', __search: '', __type: '', page: 1 })
            setOpen(!open)
          }}
          aria-controls="example-collapse-text"
          aria-expanded={open}
          >Filtro <FontAwesomeIcon icon={faFilter}/></Button>
        </Col>
      </Row>
      {isLoading ? (<Loading page />) : (<>
      <Row>
        {getTamanho(992)?(<>
          {actions.map((action, k) => {
            return (
              <Col key={k} className="font-12 mb-2 text-left col-mobile p-1">
                <Card className="h-100">
                  <Card.Body>
                    <div><b>ID: </b>{action.id}</div>
                    <div><b>BU:</b></div>
                    <div><b>Revenda: </b>{action.company.alias ?? action.company.name }</div>
                    <div><b>Nome: </b>{action.title}</div>
                    <div><b>Início: </b>{parseDateBR(action.start_at)}</div>
                    <div><b>Final: </b>{parseDateBR(action.end_at)}</div>
                    <div><b>Valor: </b>{action.funds.reduce((total, value) => {
                      return total + value.pivot.value;
                    }, 0).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL'
                    })}</div>
                    <div className="btn-group dropdown mt-0"
                    style={{
                      position: 'absolute',
                      right: '6px',
                      top: '6px'
                    }}>
                      <Can do="marketing.edit" on="App">
                        <Button className="p-1" href={'/elite/scansource-select/show/' + action.id}><EditIcon className="btn-edit"/></Button>
                      </Can>                      
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </>):(
          <Col xs="12">
            <table id="basic-datatable" className={"table table-actions table-bordered"
            +(getTamanho(940)?" table-responsive":'')}>
              <thead>
                <tr>
                  <th className="w-10p">ID</th>
                  <th className="w-10p">BU</th>
                  <th className="w-30p">Revenda</th>
                  <th className="w-20p">Nome</th>
                  <th className="w-20p">Tipo</th>
                  <th className="w-10p">Data do Pagamento</th>
                  <th className="w-10p">Valor</th>
                  <th className="w-10p">Ações</th>
                </tr>
              </thead>
              <tbody>
                {actions.map((action, k) => {           
                  const { commercial_directors } = action.company
                  return (
                    <tr key={k}>
                      <td>{action.id}</td>
                      <td>{commercial_directors[0] ? commercial_directors[0].full_name : '--'}</td>
                      <td>{action.company.alias ?? action.company.name}</td>
                      <td>{action.title}</td>
                      <td>{action.type_id === 2?"Reembolso":"Abatimento no Pedido"}</td>
                      <td>{action.pay_date ? parseDateBR(action.pay_date) : '--'}</td>
                      <td>{action.funds.reduce((total, value) => {
                        return total + value.pivot.value;
                      }, 0).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })}</td>
                      <td>
                        <div className="btn-group dropdown">
                          <Can do="scancash.edit" on="App">
                            <Link to={'/elite/scansource-select/show/' + action.id}>
                              <Button className=""><EditIcon className="btn-edit"/></Button>
                            </Link>
                          </Can>                      
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Col>
        )}
      </Row>
      <Row>
        <Col xs="12" md="6" className="d-flex justify-content-start">
          <Trans i18nKey="label:interpolateShowingRecords">
            Showing {{ from: pagination.from || '0' }} to{' '}
            {{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
            records
          </Trans>
        </Col>
        <Col xs="12" md="6" className="d-flex justify-content-end">
          <Pagination
            activePage={pagination.current_page}
            itemsCountPerPage={pagination.per_page?parseInt(pagination.per_page):0}
            totalItemsCount={pagination.total?pagination.total:0}
            pageRangeDisplayed={isMobile?3:5}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
            prevPageText="‹"
            nextPageText="›"
          />
        </Col>
      </Row>
    </>)}
    </div>
  )
}

export default ListActions